module.exports = __webpack_public_path__ + "img/law-serve-nav-icon01.aed268cf.png";